module.exports = __webpack_public_path__ + "static/media/2.5ed1851b.jpg";